<template>
  <div v-if="!isPWA && item" class="mode18-box relative" :class="getIsMobile ? 'mode_mobile' : ''">
    <div class="left-wrap">
      <div class="download-title" v-html="langInfoObj.desc"></div>


      <div v-if="!getIsMobile" class="qr-wrap">
        <div v-if="iosdownloadUrl" class="qr-box ios-wrap">
          <div class="qr-bg">
            <QRCode
              id="qrcodeios"
              ref="QrcodeiosRef"
              :id-name="'QrcodeiosRef'"
              :width="138"
              :height="138"
              :text="iosdownloadUrl"
            ></QRCode>
          </div>
          <el-button type="primary" class="down-btn" @click="downloadAppPC(1)">
            <img class="btn-img" :src="require('@/assets/home/ios.png')" alt="" />
            {{ $t("Datalang.newly_ios_i") }}
          </el-button>
        </div>
        <div v-if="andrioddownloadUrl" class="qr-box andriod-wrap">
          <div class="qr-bg">
            <QRCode
              id="qrcodeandriod"
              ref="QrcodeandriodRef"
              :id-name="'QrcodeandriodRef'"
              :width="138"
              :height="138"
              :text="andrioddownloadUrl"
            ></QRCode>
          </div>
          <el-button type="primary" class="down-btn" @click="downloadAppPC(2)">
            <img class="btn-img" :src="require('@/assets/home/android.png')" alt="" />
            {{ $t("Datalang.newly_Android_a") }}
          </el-button>
        </div>
      </div>


      <div v-if="getIsMobile" class="qr-wrap">
        <el-button
          v-if="userType === 'ios' && packageConfig.iosType === 'PACK_TYPE_DESKTOP_QUICK'"
          type="primary"
          class="down-btn"
          @click="downloadApp"
        >
          <img class="btn-img" :src="require('@/assets/home/ios.png')" alt="" />
          {{ $t("Datalang.home_Go_to") }}
        </el-button>
        <el-button v-else-if="packageConfig.iosType !== 'PACK_TYPE_DEFAULT'" type="primary" class="down-btn" @click="downloadApp">
          <img v-if="userType === 'ios'" class="btn-img" :src="require('@/assets/home/ios.png')" alt="" />
          <img v-else class="btn-img" :src="require('@/assets/home/android.png')" alt="" />
          {{ $t("Datalang.newly_download") }}
        </el-button>
      </div>

    </div>

    <el-carousel
      :interval="5000"
      arrow="never"
      :indicator-position="'none'"
      id="pc_carousel"
      :height="(getIsMobile ? bannerH5 : bannerPC) + 'px'"
    >
      <el-carousel-item
        v-for="(item, i) in listFormat"
        :key="'pc_' + i"
      >
        <div class="c-img-box h-img-box">
          <img
            class="carousel-img"
            :src="$utils.returnImgUrl(item)"
            @load="handleImageLoad"
            ref="bannerPC"
            alt
            style="display: block"
            v-exposure="{ eid: item.eid, jump_value: item.jump }"
            :data-id="item.eid"
          />
        </div>
      </el-carousel-item>
    </el-carousel>

    <!-- <div class="right-wrap">
      <img :src="$utils.returnImgUrl(langInfoObj.img)" alt="" />
    </div> -->
    <el-drawer
      :visible.sync="drawerVisible"
      :size="systemCheack() === 'ios' ? null : '20vh'"
      :with-header="false"
      direction="btt"
      append-to-body
      custom-class="download-drawer"
      @close="handleCancel"
    >
      <div class="drawer-content">
        <i
          class="iconfont el-icon-circle-close"
          :style="{ color: systemCheack() === 'ios' ? '#666' : '#fff' }"
          @click="handleCancel"
        />
        <template v-if="systemCheack() !== 'ios'">
          <div class="drawer-body">
            <img class="android-img" :src="getAndroidLogo" />
            <span>{{ $t("Datalang.click_desktop") }}</span>
          </div>

          <div class="drawer-footer">
            <el-button class="drawer-button" @click="handleCancel">
              {{ $t("Datalang.Signin_TITLE_cancel") }}
            </el-button>
            <el-button class="drawer-button" @click="handleClickToHome">
              {{ $t("Datalang.HomePage_BTM_download") }}
            </el-button>
          </div>
        </template>

        <template v-if="systemCheack() === 'ios'">
          <div class="ios-drawer-body">
            <!-- <div class="ios-title">
              <span>{{ $t("Datalang.Click_Add_to") }}</span>
              <span>{{ $t("Datalang.Save_web_version") }}</span>
            </div> -->
            <div class="ios-img-wrap">
              <!-- <span class="hostname">{{ hostname }}</span> -->
              <img class="ios-img" :src="getIOSimg" alt="" />
            </div>
          </div>
        </template>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import mode18 from "@/lobby_common/mixins_views/homeModule/mode18.js";
export default {
  mixins: [mode18],
};
</script>
<style lang="scss" scoped>
.mode18-box {
  position: relative;
  box-sizing: border-box;
  #pc_carousel {
    position: relative;
    overflow: hidden;
    border-radius: var(--radius-300);
  }
  .el-carousel__item {
    // &.pc-gradient,
    // &.h5-gradient {
    //   transform: none !important;
    //   opacity: 0;
    //   transition: opacity 0.3s;
    //   &.is-active {
    //     opacity: 1;
    //     z-index: 10;
    //   }
    // }
    .h-img-box.c-img-box {
      height: 100%;
      width: 100%;
      border-radius: 0;
      position: relative;
      img {
        max-width: 100%;
        width: 100%;
        border-radius: var(--radius-300);
        @media (max-width: 768px) {
          border-radius: var(--radius-301);
        }
      }
    }
  }
  .left-wrap {
    position: absolute;
    padding-top: 30px;
    top: 0;
    left: 20px;
    max-width: 60%;
    height: 100%;
    z-index: 10;
    .download-title {
      font-size: 30px;
      line-height: 32px;
      font-weight: bold;
      letter-spacing: 0px;
      color: var(--font-color-1602);
      @include textOverflow(3);
      ::v-deep p {
        margin: 0;
      }
      ::v-deep img {
        max-width: 100%;
      }
    }
    .qr-wrap {
      padding-top: 35px;
      padding-left: 28px;
      display: flex;
      justify-content: center;
      // align-items: center;
      text-align: center;
      .qr-box {
        &:nth-child(2) {
          margin-left: 100px;
        }
      }
      .qr-bg {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 186px;
        height: 186px;
        position: relative;
        background: url("~@/assets/home/erweima_bg.png") no-repeat;
      }
      // .andriod-wrap {
      //   margin-left: 100px;
      // }
      .down-btn {
        margin-top: 10px;
        height: 40px;
        padding: 0 20px;
        min-width: 170px;
        @include buttonPrimary;
        ::v-deep > span {
          display: inline-flex;
          justify-content: center;
          align-items: center;
        }
        .btn-img {
          width: 20px;
          margin-right: 8px;
        }
      }
    }
  }
  .right-wrap {
    img {
      max-width: 448px;
    }
  }
}
.mode18-box.mode_mobile {
  padding: 0 12px;
  align-items: center;
  background: var(--background-801);
  .left-wrap {
    .download-title {
      font-size: 14px;
      line-height: 22px;
      color: var(--font-color-1602);
    }
    .qr-wrap {
      padding-top: 30px;
      padding-left: 0;
      justify-content: flex-start;
      // align-items: center;
      .down-btn {
        margin-top: 0;
        min-width: 100px;
        height: 32px;
        padding: 0 15px;
        .btn-img {
          width: 16px;
          margin-right: 6px;
        }
      }
    }
  }
  .right-wrap {
    img {
      max-width: 134px;
    }
  }
}
.drawer-content {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: flex-end;
  // padding: 0px 12px 0px 12px;
  overflow-y: scroll;
  position: relative;

  .iconfont {
    position: absolute;
    right: 2vh;
    top: 2vh;
    z-index: 10;
    font-size: 24px;
  }
  .drawer-body {
    display: flex;
    align-items: center;
    padding: 0px 12px 0px 12px;
    .android-img {
      width: 60px;
      height: 60px;
      margin-right: 16px;
    }
  }
  .ios-drawer-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .ios-title {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-bottom: 16px;
      > span {
        &:first-child {
          font-size: 18px;
          margin-bottom: 4px;
        }
      }
    }
    .ios-img-wrap {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      .hostname {
        font-size: 2vh;
        color: #000;
        position: absolute;
        width: 100%;
        top: 2vh;
        text-align: center;
      }
      .ios-img {
        width: 100%;
        height: 100%;
        margin-right: 0;
      }
    }
  }
  .drawer-footer {
    align-self: flex-end;
    display: flex;
    justify-content: flex-end;
    margin: 0px 12px 12px 0px;
    .drawer-button {
      @include buttonPrimary;
      // color: $font-color-300 !important;
      width: 98px;
      transform: scale(1);
      transition: transform 0.15s all;
      &:active {
        transform: scale(1.08);
        transition: transform 0.15s all;
      }
    }
  }
}
</style>
<style lang="scss">
.download-drawer {
  .el-drawer__header {
    padding: 8px 0px 0px 0px;
    margin-bottom: 0px !important;
  }
}
</style>
